module.exports = __webpack_public_path__ + "img/erweima.9401e851.png";